import { clearNativeCache } from '../auth/clearNativeCache';

export const clearUserCache = (e, cacheInfo) => {
    e.preventDefault();
    cacheInfo.emptyCacheStorage();
    clearNativeCache();
    window.location.reload();
};
